import { __assign as V } from "./index60.mjs";
import { ErrorKind as x } from "./index55.mjs";
import { TYPE as l, SKELETON_TYPE as U } from "./index57.mjs";
import { SPACE_SEPARATOR_REGEX as F } from "./index62.mjs";
import { parseDateTimeSkeleton as W } from "./index63.mjs";
import { parseNumberSkeletonFromString as Y, parseNumberSkeleton as B } from "./index64.mjs";
import { getBestPattern as q } from "./index65.mjs";
var A, K = new RegExp("^".concat(F.source, "*")), j = new RegExp("".concat(F.source, "*$"));
function n(e, t) {
  return { start: e, end: t };
}
var H = !!String.prototype.startsWith && "_a".startsWith("a", 1), Q = !!String.fromCodePoint, z = !!Object.fromEntries, $ = !!String.prototype.codePointAt, J = !!String.prototype.trimStart, Z = !!String.prototype.trimEnd, c = !!Number.isSafeInteger, ee = c ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, g = !0;
try {
  var te = w("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  g = ((A = te.exec("a")) === null || A === void 0 ? void 0 : A[0]) === "a";
} catch {
  g = !1;
}
var L = H ? (
  // Native
  function(t, r, i) {
    return t.startsWith(r, i);
  }
) : (
  // For IE11
  function(t, r, i) {
    return t.slice(i, i + r.length) === r;
  }
), C = Q ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    for (var i = "", s = t.length, a = 0, o; s > a; ) {
      if (o = t[a++], o > 1114111)
        throw RangeError(o + " is not a valid code point");
      i += o < 65536 ? String.fromCharCode(o) : String.fromCharCode(((o -= 65536) >> 10) + 55296, o % 1024 + 56320);
    }
    return i;
  }
), G = (
  // native
  z ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var r = {}, i = 0, s = t; i < s.length; i++) {
        var a = s[i], o = a[0], h = a[1];
        r[o] = h;
      }
      return r;
    }
  )
), k = $ ? (
  // Native
  function(t, r) {
    return t.codePointAt(r);
  }
) : (
  // IE 11
  function(t, r) {
    var i = t.length;
    if (!(r < 0 || r >= i)) {
      var s = t.charCodeAt(r), a;
      return s < 55296 || s > 56319 || r + 1 === i || (a = t.charCodeAt(r + 1)) < 56320 || a > 57343 ? s : (s - 55296 << 10) + (a - 56320) + 65536;
    }
  }
), re = J ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(K, "");
  }
), ie = Z ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(j, "");
  }
);
function w(e, t) {
  return new RegExp(e, t);
}
var y;
if (g) {
  var M = w("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  y = function(t, r) {
    var i;
    M.lastIndex = r;
    var s = M.exec(t);
    return (i = s[1]) !== null && i !== void 0 ? i : "";
  };
} else
  y = function(t, r) {
    for (var i = []; ; ) {
      var s = k(t, r);
      if (s === void 0 || D(s) || ae(s))
        break;
      i.push(s), r += s >= 65536 ? 2 : 1;
    }
    return C.apply(void 0, i);
  };
var ve = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!r.ignoreTag, this.locale = r.locale, this.requiresOtherClause = !!r.requiresOtherClause, this.shouldParseSkeletons = !!r.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, r, i) {
      for (var s = []; !this.isEOF(); ) {
        var a = this.char();
        if (a === 123) {
          var o = this.parseArgument(t, i);
          if (o.err)
            return o;
          s.push(o.val);
        } else {
          if (a === 125 && t > 0)
            break;
          if (a === 35 && (r === "plural" || r === "selectordinal")) {
            var h = this.clonePosition();
            this.bump(), s.push({
              type: l.pound,
              location: n(h, this.clonePosition())
            });
          } else if (a === 60 && !this.ignoreTag && this.peek() === 47) {
            if (i)
              break;
            return this.error(x.UNMATCHED_CLOSING_TAG, n(this.clonePosition(), this.clonePosition()));
          } else if (a === 60 && !this.ignoreTag && N(this.peek() || 0)) {
            var o = this.parseTag(t, r);
            if (o.err)
              return o;
            s.push(o.val);
          } else {
            var o = this.parseLiteral(t, r);
            if (o.err)
              return o;
            s.push(o.val);
          }
        }
      }
      return { val: s, err: null };
    }, e.prototype.parseTag = function(t, r) {
      var i = this.clonePosition();
      this.bump();
      var s = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: l.literal,
            value: "<".concat(s, "/>"),
            location: n(i, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var a = this.parseMessage(t + 1, r, !0);
        if (a.err)
          return a;
        var o = a.val, h = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !N(this.char()))
            return this.error(x.INVALID_TAG, n(h, this.clonePosition()));
          var p = this.clonePosition(), f = this.parseTagName();
          return s !== f ? this.error(x.UNMATCHED_CLOSING_TAG, n(p, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: l.tag,
              value: s,
              children: o,
              location: n(i, this.clonePosition())
            },
            err: null
          } : this.error(x.INVALID_TAG, n(h, this.clonePosition())));
        } else
          return this.error(x.UNCLOSED_TAG, n(i, this.clonePosition()));
      } else
        return this.error(x.INVALID_TAG, n(i, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && oe(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, r) {
      for (var i = this.clonePosition(), s = ""; ; ) {
        var a = this.tryParseQuote(r);
        if (a) {
          s += a;
          continue;
        }
        var o = this.tryParseUnquoted(t, r);
        if (o) {
          s += o;
          continue;
        }
        var h = this.tryParseLeftAngleBracket();
        if (h) {
          s += h;
          continue;
        }
        break;
      }
      var p = n(i, this.clonePosition());
      return {
        val: { type: l.literal, value: s, location: p },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !se(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        // '{', '<', '>', '}'
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var r = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var i = this.char();
        if (i === 39)
          if (this.peek() === 39)
            r.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          r.push(i);
        this.bump();
      }
      return C.apply(void 0, r);
    }, e.prototype.tryParseUnquoted = function(t, r) {
      if (this.isEOF())
        return null;
      var i = this.char();
      return i === 60 || i === 123 || i === 35 && (r === "plural" || r === "selectordinal") || i === 125 && t > 0 ? null : (this.bump(), C(i));
    }, e.prototype.parseArgument = function(t, r) {
      var i = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(x.EXPECT_ARGUMENT_CLOSING_BRACE, n(i, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(x.EMPTY_ARGUMENT, n(i, this.clonePosition()));
      var s = this.parseIdentifierIfPossible().value;
      if (!s)
        return this.error(x.MALFORMED_ARGUMENT, n(i, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(x.EXPECT_ARGUMENT_CLOSING_BRACE, n(i, this.clonePosition()));
      switch (this.char()) {
        // Simple argument: `{name}`
        case 125:
          return this.bump(), {
            val: {
              type: l.argument,
              // value does not include the opening and closing braces.
              value: s,
              location: n(i, this.clonePosition())
            },
            err: null
          };
        // Argument with options: `{name, format, ...}`
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(x.EXPECT_ARGUMENT_CLOSING_BRACE, n(i, this.clonePosition())) : this.parseArgumentOptions(t, r, s, i);
        default:
          return this.error(x.MALFORMED_ARGUMENT, n(i, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), r = this.offset(), i = y(this.message, r), s = r + i.length;
      this.bumpTo(s);
      var a = this.clonePosition(), o = n(t, a);
      return { value: i, location: o };
    }, e.prototype.parseArgumentOptions = function(t, r, i, s) {
      var a, o = this.clonePosition(), h = this.parseIdentifierIfPossible().value, p = this.clonePosition();
      switch (h) {
        case "":
          return this.error(x.EXPECT_ARGUMENT_TYPE, n(o, p));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var f = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var b = this.clonePosition(), u = this.parseSimpleArgStyleIfPossible();
            if (u.err)
              return u;
            var E = ie(u.val);
            if (E.length === 0)
              return this.error(x.EXPECT_ARGUMENT_STYLE, n(this.clonePosition(), this.clonePosition()));
            var P = n(b, this.clonePosition());
            f = { style: E, styleLocation: P };
          }
          var v = this.tryParseArgumentClose(s);
          if (v.err)
            return v;
          var m = n(s, this.clonePosition());
          if (f && L(f == null ? void 0 : f.style, "::", 0)) {
            var d = re(f.style.slice(2));
            if (h === "number") {
              var u = this.parseNumberSkeletonFromString(d, f.styleLocation);
              return u.err ? u : {
                val: { type: l.number, value: i, location: m, style: u.val },
                err: null
              };
            } else {
              if (d.length === 0)
                return this.error(x.EXPECT_DATE_TIME_SKELETON, m);
              var _ = d;
              this.locale && (_ = q(d, this.locale));
              var E = {
                type: U.dateTime,
                pattern: _,
                location: f.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? W(_) : {}
              }, X = h === "date" ? l.date : l.time;
              return {
                val: { type: X, value: i, location: m, style: E },
                err: null
              };
            }
          }
          return {
            val: {
              type: h === "number" ? l.number : h === "date" ? l.date : l.time,
              value: i,
              location: m,
              style: (a = f == null ? void 0 : f.style) !== null && a !== void 0 ? a : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var O = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(x.EXPECT_SELECT_ARGUMENT_OPTIONS, n(O, V({}, O)));
          this.bumpSpace();
          var T = this.parseIdentifierIfPossible(), I = 0;
          if (h !== "select" && T.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(x.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, n(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var u = this.tryParseDecimalInteger(x.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, x.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (u.err)
              return u;
            this.bumpSpace(), T = this.parseIdentifierIfPossible(), I = u.val;
          }
          var S = this.tryParsePluralOrSelectOptions(t, h, r, T);
          if (S.err)
            return S;
          var v = this.tryParseArgumentClose(s);
          if (v.err)
            return v;
          var R = n(s, this.clonePosition());
          return h === "select" ? {
            val: {
              type: l.select,
              value: i,
              options: G(S.val),
              location: R
            },
            err: null
          } : {
            val: {
              type: l.plural,
              value: i,
              options: G(S.val),
              offset: I,
              pluralType: h === "plural" ? "cardinal" : "ordinal",
              location: R
            },
            err: null
          };
        }
        default:
          return this.error(x.INVALID_ARGUMENT_TYPE, n(o, p));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(x.EXPECT_ARGUMENT_CLOSING_BRACE, n(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, r = this.clonePosition(); !this.isEOF(); ) {
        var i = this.char();
        switch (i) {
          case 39: {
            this.bump();
            var s = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(x.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, n(s, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(r.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(r.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, r) {
      var i = [];
      try {
        i = Y(t);
      } catch {
        return this.error(x.INVALID_NUMBER_SKELETON, r);
      }
      return {
        val: {
          type: U.number,
          tokens: i,
          location: r,
          parsedOptions: this.shouldParseSkeletons ? B(i) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, r, i, s) {
      for (var a, o = !1, h = [], p = /* @__PURE__ */ new Set(), f = s.value, b = s.location; ; ) {
        if (f.length === 0) {
          var u = this.clonePosition();
          if (r !== "select" && this.bumpIf("=")) {
            var E = this.tryParseDecimalInteger(x.EXPECT_PLURAL_ARGUMENT_SELECTOR, x.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (E.err)
              return E;
            b = n(u, this.clonePosition()), f = this.message.slice(u.offset, this.offset());
          } else
            break;
        }
        if (p.has(f))
          return this.error(r === "select" ? x.DUPLICATE_SELECT_ARGUMENT_SELECTOR : x.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, b);
        f === "other" && (o = !0), this.bumpSpace();
        var P = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(r === "select" ? x.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : x.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, n(this.clonePosition(), this.clonePosition()));
        var v = this.parseMessage(t + 1, r, i);
        if (v.err)
          return v;
        var m = this.tryParseArgumentClose(P);
        if (m.err)
          return m;
        h.push([
          f,
          {
            value: v.val,
            location: n(P, this.clonePosition())
          }
        ]), p.add(f), this.bumpSpace(), a = this.parseIdentifierIfPossible(), f = a.value, b = a.location;
      }
      return h.length === 0 ? this.error(r === "select" ? x.EXPECT_SELECT_ARGUMENT_SELECTOR : x.EXPECT_PLURAL_ARGUMENT_SELECTOR, n(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !o ? this.error(x.MISSING_OTHER_CLAUSE, n(this.clonePosition(), this.clonePosition())) : { val: h, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, r) {
      var i = 1, s = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (i = -1);
      for (var a = !1, o = 0; !this.isEOF(); ) {
        var h = this.char();
        if (h >= 48 && h <= 57)
          a = !0, o = o * 10 + (h - 48), this.bump();
        else
          break;
      }
      var p = n(s, this.clonePosition());
      return a ? (o *= i, ee(o) ? { val: o, err: null } : this.error(r, p)) : this.error(t, p);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var r = k(this.message, t);
      if (r === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return r;
    }, e.prototype.error = function(t, r) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: r
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (L(this.message, t, this.offset())) {
        for (var r = 0; r < t.length; r++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var r = this.offset(), i = this.message.indexOf(t, r);
      return i >= 0 ? (this.bumpTo(i), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var r = this.offset();
        if (r === t)
          break;
        if (r > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && D(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), r = this.offset(), i = this.message.charCodeAt(r + (t >= 65536 ? 2 : 1));
      return i ?? null;
    }, e;
  })()
);
function N(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function se(e) {
  return N(e) || e === 47;
}
function oe(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function D(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function ae(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
export {
  ve as Parser
};
